import React from 'react';
import { withContent } from '../../hoc/withContext';
import {
  PriceBannerBlockContainer,
  PriceBannerDescription, PriceBannerImageContainer, PriceBannerInformationContainer,
  PriceMonthText, PriceBannerSubscriptionButton, SubscriptionPriceText, PrinceTextContainer,
  UbisoftPlusLogoContainer, SubscriptionPriceContainer
} from './PriceBannerBlockStyle';
import { IContent } from '../../types';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoft_plus_logo.svg';

import PictureImage from '../UI/Image/Picture';
import SubscriptionButton from '../SubscriptionButton/SubscriptionButton';
import '../Hero/Hero.scss';
import CONFIG from '../../config';

const IMAGE_NAME = 'valhala_fenyx_rysing_background';

interface IPriceBannerProps {
  context?: IContent;
}

const PriceBannerBlock = ({ context }: IPriceBannerProps) => {
  return (
    <PriceBannerBlockContainer>
      <PriceBannerImageContainer>
        <PictureImage
          images={[{
            imageName: IMAGE_NAME + '_desktop',
            minWidth: 850
          },{
            imageName: IMAGE_NAME + '_tablet',
            minWidth: 461
          }, {
            imageName: IMAGE_NAME + '_mobile',
            minWidth: 0
          }
          ]}
          extension="jpg"
          altText={context.priceBanner.imageAlt}
          className={['']}
        />
      </PriceBannerImageContainer>
      <PriceBannerInformationContainer>
        <UbisoftPlusLogoContainer>
          <UbisoftPlusLogo />
        </UbisoftPlusLogoContainer>
        <PriceBannerDescription>{context.priceBanner.subTitle}</PriceBannerDescription>
        <SubscriptionPriceContainer>
          <discover-components-subscription-price
            locale={context.lang.split('_')[0]}
            theme={CONFIG.isUPC ? 'uplay' : 'store'}
            customTheme={CONFIG.isUPC ? 'uplay' : 'store'}
            size="defaultSizes"
            textColor={'white'}
          ></discover-components-subscription-price>
        </SubscriptionPriceContainer>
        <PriceBannerSubscriptionButton>
          <SubscriptionButton idToAttach={'priceBannerSubscriptionButton'} />
        </PriceBannerSubscriptionButton>
      </PriceBannerInformationContainer>
    </PriceBannerBlockContainer>
  );
};

export default withContent(PriceBannerBlock);
